import axiosapi from "./../axiosAPI";

// Create / Fetch Incidents Location Report
export const incidentsLocationRpt = async (
    zone,
    region,
    district,
    startdate,
    enddate,
    attributetype,
    setReportData,
    setFetcherror,
    monitorreport,
    monitorId,
    disaggregation,
    exportReport = false,
    exportType = "pdf",
    callback = null
) => {
    const PushItem = {
        zone,
        region,
        district,
        startdate,
        enddate,
        attributetype,
        monitorreport,
        monitorId,
        disaggregation,
        exportReport,
        exportType
    };

    try {
        if (!exportReport) {
            // Normal JSON report fetch
            const res = await axiosapi.post("/incidentsattributerpt/", PushItem);

            setReportData(res.data.data);

            if (callback && typeof callback === "function") {
                callback(res.data, null);
            }
        } else {
            // Export mode (PDF, Excel, CSV) - request with responseType 'blob'
            const response = await axiosapi.post(
                "/incidentsattributerpt/",
                PushItem,
                { responseType: "blob" } // only this request returns blob
            );

            // Extract filename from headers or fallback
            const contentDisposition = response.headers["content-disposition"];
            let filename = `incident_report_${Date.now()}.${exportType}`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1].replace(/['"]/g, "");
                }
            }

            // Create blob and trigger download
            const blob = new Blob([response.data], {
                type: response.headers["content-type"]
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            if (callback && typeof callback === "function") {
                callback({ success: true, filename }, null);
            }
        }
    } catch (err) {
        console.error("Error fetching/exporting report:", err);

        if (err.response) {
            setFetcherror("Could not fetch incidents report");
            console.log(err.response.data);
            console.log(err.response.status);
        } else {
            setFetcherror("No response from server");
        }

        if (callback && typeof callback === "function") {
            callback(null, true);
        }
    }
};
